module.exports = __webpack_public_path__ + "img/data-center.5205a298.png";